export default "__VITE_ASSET__cecd2ba8__"